module.exports = __webpack_public_path__ + "img/erp.416dd475.png";